module.exports = "https://static.energy5.com/_next/static/images/brand1-de57c5de7e4072bbefc2636384f5234b.png";